<template lang="pug">
div
	.position-relative
		//- Hero for FREE version
		section.section.section-lg.section-hero.heroPlastomex
			div(style='height: fit-content;')
				h1.h-titulo Contacto
				p.lead.h-subtitulo  Queremos trabajar contigo
	//- You write code for this content block in another  file
	.container
		.d-flex.justify-content-center
			h2.sublinea-centro
				span ¿Tienes dudas?
				| Contáctanos

		//article.row.align-items-center.text-md-center.justify-content-center
			.col-md-3
				svg(style='width:50px;height:50px;', viewBox='0 0 24 24')
					path(d='M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z')
				a(href='mailto:servicioalcliente@plastomex.com') servicioalcliente@plastomex.com
			//.col-md-3.d-inline
				svg(style='width:50px;height:50px;', viewBox='0 0 24 24')
					path(d='M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z')
				a(href='tel:4432041123,0') (443) 204 1123  &nbsp;&nbsp;ext. 0
			//.col-md-3.d-inline
				svg(style='width:50px;height:50px;', viewBox='0 0 24 24')
					path(d='M17.25,18H6.75V4H17.25M14,21H10V20H14M16,1H8A3,3 0 0,0 5,4V20A3,3 0 0,0 8,23H16A3,3 0 0,0 19,20V4A3,3 0 0,0 16,1Z')
				a(href='tel:4433951818') (443) 3 95 1818
			//.col-md-3.d-inline
				svg(style='width:50px;height:50px;', viewBox='0 0 24 24')
					path(d='M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z')
				a(href='https://wa.me/524433951818') Enviar WhatsApp
		article
			h4  Ponte en contacto con nosotros
			form#contacto( @submit.prevent="contacto()")
				.row
					.col-md-6
						.form-group
							input#nombre.form-control(type='text',name="nombre" placeholder='Nombre' v-model="form.nombre" required)
							input#empresa.form-control(type='text',name="empresa" placeholder='Empresa' v-model="form.empresa" required)
							input#email.form-control(type='email',name="email", placeholder='Email' v-model="form.email" required)
							input#tel.form-control(type='tel',name="tel" pattern="[0-9]{10}" placeholder='Teléfono (10 digitos)' v-model="form.tel" required)
							input#asunto.form-control(type='text',name="asunto" placeholder='Asunto' v-model="form.asunto" required)
					.col-md-6
						.form-group
							textarea#exampleFormControlTextarea1.form-control(rows='10', placeholder='Escribe aquí tus comentarios...')
					.col-12
						button.btn.btn-primary(type='submit') Enviar
			
			base-alert.alert-dismissible(:type='alert.type', v-if='alert')
				span.alert-inner--icon
					i.ni.ni-like-2
				span.alert-inner--text
					strong ¡{{ alert.strong }}!
					|  {{alert.msg}}
				button.close(type='button', @click.stop='alert=false' data-dismiss='alert', aria-label='Close')
					span(aria-hidden='true' ) ×

		//article#ubicaciones.row.text-center
			.col-12.col-md
				h4 Planta Morelia
				.direccion
					svg.d-inline.svg-md(viewBox='0 0 24 24', data-sal="zoom-in", data-sal-duration="900")
						path(d='M4,18V20H8V18H4M4,14V16H14V14H4M10,18V20H14V18H10M16,14V16H20V14H16M16,18V20H20V18H16M2,22V8L7,12V8L12,12V8L17,12L18,2H21L22,12V22H2Z')
					.ml-3
						span Av. Oriente 4 #20
						span Col. Ciudad Industrial
						span Morelia, Michoacán, México. 
				iframe(width='100%', height='400px', src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.506952675934!2d-101.14438155425172!3d19.730714717699716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842d11c632bd792d%3A0x29dbdb6e4b097428!2sPlastomex+Morelia!5e0!3m2!1ses-419!2smx!4v1555094858342!5m2!1ses-419!2smx', frameborder='0', style='border:0;', allowfullscreen='')
			.col-12.col-md
				h4 Planta Cd. Guzmán
				.direccion
					svg.svg-md(viewBox='0 0 24 24' data-sal="zoom-in", data-sal-duration="900")
						path(d='M4,18V20H8V18H4M4,14V16H14V14H4M10,18V20H14V18H10M16,14V16H20V14H16M16,18V20H20V18H16M2,22V8L7,12V8L12,12V8L17,12L18,2H21L22,12V22H2Z')
					.ml-3
						span Av. José María González de Hermosillo #944 Int. 2 
						span Col. Centro, CP: 49000
						span Ciudad Guzmán, Zapotlán el Grande, Jalisco
				iframe(width='100%', height='400px', src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2066.6291540335005!2d-103.4898518990097!3d19.69578370125366!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x93d802e91bbb9fc6!2sPlastomex+CDG!5e0!3m2!1ses!2smx!4v1562599429157!5m2!1ses!2smx', frameborder='0', style='border:0;', allowfullscreen)
				
</template>

<script>
import sal from "sal.js"

    export default {
			data(){
				return{
					form:{},
					alert: false,
				}
			},
			mounted(){
				sal({
					threshold: 1
				});
			},
			methods:{
				contacto(){
					//console.log(JSON.stringify(this.form))

					fetch('https://mail.plastomex.com/sendmail', {
						method:'post',
						body: JSON.stringify( {...this.form, from:'contacto'}),
						headers:{'Content-Type': 'application/json' },
						mode: 'cors'
					})
						.then(response => response.json())
						.catch(error => {
							this.$swal('Error','Error al enviar el mensaje','error')
							console.error('Error:', error)
						})
							.then( data => { 
								console.log(data);
								if (data.messageId) 
									this.$swal('Enviado','El mensaje se envió correctamente','success')
								
								/* this.alert = {msg:'Correo enviado con exito', strong:'Exito', type:'success'},
								this.form = {}
								console.log(data)  */
							})
							.catch(error => {
								this.$swal('Error','Error al enviar el mensaje','error')
								console.error('Error:', error)
							})
					}
			}
    }
</script>

<style lang="scss" scoped>
.contacto{
	& > div{
		padding: .5em 1em .5em 4em;
	}
}
.heroPlastomex{
	background-image: url('/img/optimizadas/CONTACTO.jpg');
}
.webp .heroPlastomex{
	background-image: url('/img/optimizadas/CONTACTO.webp');
}
</style>